module.exports = __webpack_public_path__ + "8da5233cf8eed53eb3ff05cd50a3093c.png";